import './index.scss'

const Skeleton = ({ children }: { children: TChildren }) => {
    return <span className="skeleton">{children}</span>
}

export default Skeleton
